import { jsxs, jsx } from "react/jsx-runtime";
import { useTranslations } from "@vocab/react";
import { Box } from "braid-design-system";
import { translations } from "../../../../components/ProfileMonthPicker/.vocab/index.mjs";
import { useMonthNames } from "../ProfileMonthPickerRenderer/ProfileMonthPickerRenderer.mjs";
import { checkBoxMargin, stillInRoleTransition, checkBox, monthPickerHiddenTransition, dropdownMargin, monthPickerVisibleTransition, checkBoxOnNewLine, container } from "./ProfileMonthPickerToggleRenderer.css.mjs";
import { profileMonthPickerWidth } from "../ProfileMonthPickerRenderer/ProfileMonthPickerRenderer.css.mjs";
const ProfileMonthPickerToggleRenderer = ({
  children,
  hideMonthPicker,
  checkbox,
  checkboxOnNewLine
}) => {
  const monthNames = useMonthNames();
  const { t } = useTranslations(translations);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: {
        [container]: true,
        [checkBoxOnNewLine]: checkboxOnNewLine
      },
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            className: {
              [checkBox]: true,
              [stillInRoleTransition]: hideMonthPicker && !checkboxOnNewLine,
              [checkBoxMargin]: !checkboxOnNewLine
            },
            children: checkbox
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            className: {
              [profileMonthPickerWidth]: true,
              [monthPickerVisibleTransition]: true,
              [dropdownMargin]: !checkboxOnNewLine,
              [monthPickerHiddenTransition]: hideMonthPicker && !checkboxOnNewLine
            },
            ...hideMonthPicker && checkboxOnNewLine ? { display: "none" } : {},
            ...checkboxOnNewLine ? { paddingBottom: "xsmall" } : {},
            children: children({
              monthPickerProps: {
                monthNames,
                monthLabel: t("Month"),
                yearLabel: t("Year")
              }
            })
          }
        )
      ]
    }
  );
};
export {
  ProfileMonthPickerToggleRenderer
};
